export type VariableValueType = 'string' | 'array';

export const VariableValueTypes: VariableValueType[] = ['string', 'array'];

export type VariableType = 'DEFAULT' | 'CUSTOM' | 'PROMPT_OUTPUT' | 'PROMPT_USER_INPUT';

export const VariableTypes: VariableType[] = [
    'DEFAULT',
    'CUSTOM',
    'PROMPT_OUTPUT',
    'PROMPT_USER_INPUT',
];

export interface StringVariableConfig {
    id: string;
    key: string;
    type: VariableType;
    valueType: 'string';
    value: string | undefined;
    description: string | undefined;
    editable: boolean;
}

export interface ArrayVariableConfig {
    id: string;
    key: string;
    type: VariableType;
    valueType: 'array';
    value: string[] | undefined;
    description: string | undefined;
    editable: boolean;
}

export type VariableConfig = StringVariableConfig | ArrayVariableConfig;
